import { useEffect, useState } from "react";
import api from "@/lib/api";
import { AlertTriangle } from "lucide-react";

export function OvertimeBanner({ companyId, isAdmin }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!companyId) return;
    api.get("/alerts/overtime", { params: isAdmin ? { company_id: companyId } : {} }).then((r) => setD(r.data)).catch(() => {});
  }, [companyId, isAdmin]);
  if (!d || d.alerts.length === 0) return null;
  return (
    <div data-testid="overtime-banner" className="rounded-xl border border-amber-300 bg-amber-50 dark:bg-amber-500/10 dark:border-amber-500/30 p-4 flex gap-3">
      <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
      <div className="text-sm">
        <div className="font-semibold text-amber-800 dark:text-amber-300">Overtime watch — week of {d.week_start.slice(5, 7)}/{d.week_start.slice(8, 10)}: {d.over_count} over {d.threshold}h, {d.approaching_count} approaching</div>
        <div className="mt-1 flex flex-wrap gap-2">
          {d.alerts.map((a) => (
            <span key={a.employee_id} data-testid={`ot-${a.employee_id}`} className={`px-2 py-0.5 rounded-md text-xs font-medium ${a.over ? "bg-rose-100 text-rose-700" : "bg-amber-100 text-amber-800"}`}>
              {a.name} · <span className="font-mono-num">{a.hours}h</span>{a.over && ` (+${a.overtime_hours} OT)`}
            </span>
          ))}
        </div>
        <p className="text-xs text-amber-700 dark:text-amber-400 mt-1">Review timesheets before running payroll; hours over 40 are paid at 1.5×.</p>
      </div>
    </div>
  );
}
